export default __webpack_public_path__ + "static/media/bolt-solid.36924b9f.svg";